<template>
    <section class="dashboard">
        <div class="container">
            <div class="align-center attention">
                <div><img class="attention__pic" src="@/assets/images/dashboard/info.svg" alt=""></div>
                <div  class="attention__text">
                    <span v-html="$t('members.dashboard.info')"></span>
                </div>
            </div>

            <div class="list">
                <DashboardItem
                        v-for="(member, idx) in members"
                        :key="idx"
                        :route="member.route"
                        :type="member.type"
                        :title="member.text"
                />
            </div>

            <div class="align-center flex lg10 mx-auto attention dashboard__warning">
                <div class="attention__pic"><img src="@/assets/images/dashboard/warning.svg" alt=""></div>
                <div class="attention__text">
                    {{$t('members.dashboard.warning')}}
                </div>
            </div>
        </div>

        <Partners/>
    </section>
</template>

<script>
    import DashboardItem from "../../studios/Dashboard/DashboardItem";
    import Partners from "../Partners";

    export default {
        components: {
            DashboardItem,
            Partners,
        },

        data() {
            return {
                members: [
                    {
                        route: '/members/studio-finder',
                        text: this.$t('members.dashboard.studio_finder'),
                        type: 'studio-finder'
                    },
                    {
                        route: '/members/view-my-visits',
                        text: this.$t('members.dashboard.view_visits'),
                        type: 'view-visits',
                    },
                    {
                        route: '/members/faq',
                        text: this.$t('members.dashboard.question_answer'),
                        type: 'question-answer'
                    }
                ]
            }
        }
    }
</script>

<style lang="sass" scoped>

    .dashboard
        &__info, &__warning
            margin-left: 12px
            font-size: 14px
            flex: 1
            letter-spacing: 0.005em
            color: $color--dark-lighten
            +reg


        &__warning
            margin: 40px 0 32px
            padding-top: 32px
            border-top: 1px solid rgba(#0B234B, 0.15)

            &-text
                margin-left: 10px

</style>